import React, { useContext, useState } from 'react'

import BillingAddressContext from 'common/contexts/billing-address'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import useHppContext from 'common/hooks/use-hpp-context'

axiosRetry(axios, { retries: 1 })

export function BillingAddressContextProvider({ children }) {
  const {
    kp: { billingAddressFlow } = {
      billingAddressFlow: null
    }
  } = useHppContext()

  const activateCorrectionEndpoint =
    billingAddressFlow && billingAddressFlow.urls && billingAddressFlow.urls.activateCorrection
  const [shouldEditBillingAddress, editBillingAddress] = useState(false)

  const [shouldProceedToBuy, setProceedToBuy] = useState(false)

  function setBillingAddressCorrection() {
    return axios.post(activateCorrectionEndpoint)
  }

  return (
    <BillingAddressContext.Provider
      value={{
        shouldEditBillingAddress,
        editBillingAddress,
        shouldProceedToBuy,
        setProceedToBuy,
        setBillingAddressCorrection
      }}
    >
      {children}
    </BillingAddressContext.Provider>
  )
}

export function useBillingAddressContext() {
  return useContext(BillingAddressContext)
}
